export default {

    getUUID() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16))
    },

    isValidDate(dateString) {
        const regEx = /^\d{4}-\d{2}-\d{2}$/;
        if (!dateString.match(regEx)) return false;  // Invalid format
        const d = new Date(dateString);
        const dNum = d.getTime();
        if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
        return d.toISOString().slice(0, 10) === dateString;
    },
    copyObject(source, deep) {
        let o, prop, type;

        if (typeof source != 'object' || source === null) {
            // What do to with functions, throw an error?
            o = source;
            return o;
        }

        o = new source.constructor();

        for (prop in source) {

            if (source.hasOwnProperty(prop)) {
                type = typeof source[prop];

                if (deep && type === 'object' && source[prop] !== null) {
                    o[prop] = this.copyObject(source[prop]);

                } else {
                    o[prop] = source[prop];
                }
            }
        }
        return o;
    },
    isMobile: {

            Android: function() {
                return navigator.userAgent.match(/Android/i);
            },
            BlackBerry: function() {
                return navigator.userAgent.match(/BlackBerry/i);
            },
            iOS: function() {
                return navigator.userAgent.match(/iPhone|iPad|iPod/i);
            },
            Opera: function() {
                return navigator.userAgent.match(/Opera Mini/i);
            },
            Windows: function() {
                return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
            },
            any: function() {
                return (this.Android() || this.BlackBerry() || this.iOS() || this.Opera() || this.Windows());
            }
    },
    isIE: {
        Ten: function() {
            return navigator.userAgent.match(/MSIE 10/i);
        }
    },
    isValidImageFormat(file) {
        const validFormats = ['image/jpeg', 'image/jpg', 'image/png'];
        return validFormats.includes(file.type);
    },
    isValidPdfOrImageFormat(file) {
        const validFormats = ['application/pdf', 'image/jpeg', 'image/jpg', 'image/png', 'image/bmp'];
        return validFormats.includes(file.type);
    },
    copyStringToClipboard(str) {
        // Create new element
        const el = document.createElement('textarea');
        // Set value (string to be copied)
        el.value = str;
        // Set non-editable to avoid focus and move outside of view
        el.setAttribute('readonly', '');
        document.body.appendChild(el);
        // Select text inside element
        el.select();
        // Copy text to clipboard
        document.execCommand('copy');
        // Remove temporary element
        document.body.removeChild(el);
    },
    getMappedWeekdays(weekdays) {
        return weekdays.map((item) => {
            return {
                value: item.id,
                label: item.name
            };
        });
    },
    getMappedPayrollSchedulers(items) {
        return items.map((item) => {
            return {
                value: item.id,
                label: item.name
            };
        });
    },
    getMappedCountries(items) {
        return items.map((item) => {
            return {
                value: item.id,
                label: item.name
            };
        });
    }
}